const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";

export const getReferrerName = ({ firstName, lastName }) => `${firstName ?? ""} ${lastName ?? ""}`.trim();

export const isReferrerOutsideClinic = (referrerRecord, clinicId) => {
  if (!referrerRecord || !clinicId) {
    return false;
  }
  const { workingClinicId } = referrerRecord;
  if (!workingClinicId) {
    return false;
  }
  return workingClinicId !== clinicId;
};

export const scopeReferrersToClinic = (referrers, clinicId, currentReferrer) => {
  if (!clinicId) {
    // Legacy Coreplus links a referrer to a clinic through referrerLocation, created
    // on demand, so every pairing it can produce is a real one and the whole
    // directory stays offered. Against pms-api a referrer belongs to exactly one
    // clinic, and nothing can be checked before one is chosen.
    return isDataFromPMS ? [] : referrers;
  }

  const filtered = referrers.filter((referrerRecord) => !isReferrerOutsideClinic(referrerRecord, clinicId));
  if (currentReferrer && !filtered.some(({ id }) => id === currentReferrer.id)) {
    return [...filtered, currentReferrer];
  }
  return filtered;
};

/**
 * Label the referrers a picker should offer.
 *
 * Duplicate names are counted across `allReferrers` — the whole directory — not
 * across the subset being labelled. Counting the subset means a clinic filter that
 * happens to leave one of several same-named referrers standing silently drops the
 * disambiguating suffix, and the picker then shows a bare name that identifies
 * nothing. Whoever is choosing has no way to tell it apart from its namesakes.
 */
export const labelReferrers = (referrers, allReferrers = referrers) => {
  const nameCounts = allReferrers.reduce((counts, referrerRecord) => {
    const key = getReferrerName(referrerRecord).toLowerCase();
    counts[key] = (counts[key] || 0) + 1;
    return counts;
  }, {});
  return referrers.map((referrerRecord) => {
    const name = getReferrerName(referrerRecord);
    const hasDuplicateName = nameCounts[name.toLowerCase()] > 1;
    return {
      label: hasDuplicateName ? `${name} (${referrerRecord.providerNumber || referrerRecord.id})` : name,
      referrer: referrerRecord,
    };
  });
};
